module.exports = __webpack_public_path__ + "fonts/Colfax-Medium.b5e83fbb.otf";